import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo, images } from '../data/mock';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#152E1C] text-white">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 py-10 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12 text-left">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-2 order-1">
            <div className="flex items-center justify-start gap-2 mb-3 sm:mb-4">
              <img
                src={images.logo}
                alt="MeisterGrün Logo"
                className="h-12 sm:h-14 md:h-[63px] w-auto"
              />
            </div>
            <p className="text-white/70 text-sm sm:text-base mb-4 sm:mb-6 max-w-md leading-relaxed">
              Ihr zuverlässiger Partner für Hausmeisterdienstleistungen,
              Gartenarbeit und kleine Reparaturen in Frankfurt, Kahl am Main und Umgebung.
            </p>
            <a
              href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
              className="inline-flex items-center justify-center gap-2 bg-[#FFD700] text-[#1E4D2B] w-full sm:w-auto px-6 py-3.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base hover:bg-[#FFE44D] transition-all duration-200 touch-manipulation"
            >
              <Phone className="w-5 h-5 shrink-0" />
              {companyInfo.phone}
            </a>
          </div>

          {/* Contact Info */}
          <div className="order-2">
            <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-6">Kontakt</h3>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-white/70 hover:text-[#FFD700] transition-colors text-sm sm:text-base py-1 touch-manipulation"
                >
                  <Phone className="w-4 h-4 shrink-0" />
                  <span className="break-all sm:break-normal">{companyInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-white/70 hover:text-[#FFD700] transition-colors text-sm sm:text-base py-1 touch-manipulation break-all"
                >
                  <Mail className="w-4 h-4 shrink-0" />
                  {companyInfo.email}
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-white/70 text-sm sm:text-base">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>
                    {companyInfo.address.street}<br />
                    {companyInfo.address.zip} {companyInfo.address.city}
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="order-3 sm:order-4">
            <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-6">Rechtliches</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/impressum"
                  className="inline-block text-white/70 hover:text-[#FFD700] transition-colors text-sm sm:text-base py-1 touch-manipulation"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  className="inline-block text-white/70 hover:text-[#FFD700] transition-colors text-sm sm:text-base py-1 touch-manipulation"
                >
                  Datenschutzerklärung
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 sm:mt-10 md:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-left">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-1 sm:gap-2 md:gap-4">
            <p className="text-white/50 text-xs sm:text-sm">
              © {currentYear} MeisterGrün. Alle Rechte vorbehalten.
            </p>
            <p className="text-white/50 text-xs sm:text-sm hidden md:block">|</p>
            <p className="text-white/50 text-xs sm:text-sm">
              Hausmeisterservice in Frankfurt & Kahl am Main
            </p>
          </div>
          <a
            href="https://zeuz-it.de/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/50 text-xs sm:text-sm hover:text-[#FFD700] transition-colors touch-manipulation"
          >
            created by <span className="font-semibold">ZeuZ IT</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
